'use client';
import { useRef, useState } from 'react';
import { Box, Card, CardContent, Tab, Tabs } from '@mui/material';

import { SportsCommentsTab } from '@/components';

interface SportsCommentsSectionProps {
  seriesId: string | number;
}

export const SportsCommentsSection = ({ seriesId }: SportsCommentsSectionProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleTabChange = (_: unknown, val: number) => setActiveTab(val);

  return (
    <Card
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 500, fontSize: '0.9375rem' },
              '& .Mui-selected': { color: 'primary.main', fontWeight: 600 },
              '& .MuiTabs-indicator': { bgcolor: 'primary.main' },
            }}
          >
            <Tab label={`Comments`} />
          </Tabs>
        </Box>

        <CardContent sx={{ p: 2 }}>
          <SportsCommentsTab eventId={seriesId} scrollContainerRef={scrollContainerRef} />
        </CardContent>
      </CardContent>
    </Card>
  );
};

export default SportsCommentsSection;
